import { IOrderRestatement } from "@pulse-ui/codegen/generated_ts/drop_copy";
import { IUserNotification } from "@pulse-ui/codegen/generated_ts/session";

export const isOrderRestatement = (rpt: any): rpt is IOrderRestatement => {
  return (rpt as IOrderRestatement).reason !== undefined;
};

export const isUserNotification = (rpt: any): rpt is IUserNotification => {
  return (rpt as IUserNotification).user_status !== undefined;
};
